import {hideElem, queryElems, showElem, toggleElem} from '../utils/dom.ts';
import {fomanticQuery} from '../modules/fomantic/base.ts';
import {EventUserSelected, looksLikeEmailAddressCheck} from './comp/SearchUserBox.ts';

const {appSubUrl} = window.config;

// AllSpice: check conditions which make a team a committer team
function shouldShowWarning(pageContent: Element) {
  const unit1 = pageContent.querySelector<HTMLInputElement>('input[name=unit_1]:checked');
  const canCreate = pageContent.querySelector<HTMLInputElement>('input[name=can_create_org_repo]:checked');
  const permission = pageContent.querySelector<HTMLInputElement>('input[name=permission]:checked');
  return unit1?.value === '2' || canCreate?.value === 'on' || permission?.value === 'admin';
}

function initOrgTeamSettings() {
  // on the page "page-content organization new team"
  const pageContent = document.querySelector('.page-content.organization.new.team');
  if (!pageContent) return;

  const committerRestricted = pageContent.querySelector('.committer-restricted') !== null;
  const submitButton = pageContent.querySelector<HTMLButtonElement>('.ui.primary.button');

  queryElems(pageContent, 'input[name=permission]', (el) => el.addEventListener('change', () => {
    // Change team access mode
    const val = pageContent.querySelector<HTMLInputElement>('input[name=permission]:checked')?.value;
    toggleElem(pageContent.querySelectorAll('.team-units'), val !== 'admin');

    // AllSpice: committer warning logic
    if (val === 'admin') {
      showElem(pageContent.querySelectorAll('.committer-warning'));
      if (committerRestricted && submitButton) submitButton.classList.add('disabled');
    } else if (!shouldShowWarning(pageContent)) {
      hideElem(pageContent.querySelectorAll('.committer-warning'));
      if (submitButton) submitButton.classList.remove('disabled');
    }
  }));

  // AllSpice: check if file write access or can_create_org_repo selected
  queryElems(pageContent, 'input[name=can_create_org_repo]', (el) => el.addEventListener('change', () => {
    const val = pageContent.querySelector<HTMLInputElement>('input[name=can_create_org_repo]:checked')?.value;
    if (val === 'on') {
      showElem(pageContent.querySelectorAll('.committer-warning'));
      if (committerRestricted && submitButton) submitButton.classList.add('disabled');
    } else if (!shouldShowWarning(pageContent)) {
      hideElem(pageContent.querySelectorAll('.committer-warning'));
      if (submitButton) submitButton.classList.remove('disabled');
    }
  }));

  queryElems(pageContent, 'input[name=unit_1]', (el) => el.addEventListener('change', () => {
    const val = pageContent.querySelector<HTMLInputElement>('input[name=unit_1]:checked')?.value;
    if (val === '2') {
      showElem(pageContent.querySelectorAll('.committer-warning'));
      if (committerRestricted && submitButton) submitButton.classList.add('disabled');
    } else if (!shouldShowWarning(pageContent)) {
      hideElem(pageContent.querySelectorAll('.committer-warning'));
      if (submitButton) submitButton.classList.remove('disabled');
    }
  }));
}

function initOrgTeamSearchRepoBox() {
  // on the page "page-content organization teams"
  const $searchRepoBox = fomanticQuery('#search-repo-box');
  $searchRepoBox.search({
    minCharacters: 2,
    apiSettings: {
      url: `${appSubUrl}/repo/search?q={query}&uid=${$searchRepoBox.data('uid')}`,
      onResponse(response: any) {
        const items = [];
        for (const item of response.data) {
          items.push({
            title: item.repository.full_name.split('/')[1],
            description: item.repository.full_name,
          });
        }
        return {results: items};
      },
    },
    searchFields: ['full_name'],
    showNoResults: false,
  });
}

// AllSpice: team member invite with email detection
export function initOrgTeamMembers() {
  const searchUserBox = document.querySelector('#search-user-box');
  const inviteButton = document.querySelector('#invite-team-member-button');
  if (!searchUserBox || !inviteButton) return;

  const input = searchUserBox.querySelector('input');
  if (!input) return;

  const labelAdd = inviteButton.getAttribute('data-label-add');
  const labelInvite = inviteButton.getAttribute('data-label-invite');

  searchUserBox.addEventListener(EventUserSelected, (e: Event) => {
    inviteButton.classList.remove('disabled');
    const title = (e as CustomEvent).detail?.title || '';
    if (looksLikeEmailAddressCheck.test(title)) {
      inviteButton.textContent = labelInvite;
    } else {
      inviteButton.textContent = labelAdd;
    }
  });

  input.addEventListener('input', () => {
    inviteButton.classList.add('disabled');
    inviteButton.textContent = labelAdd;
  });
}

export function initOrgTeam() {
  if (!document.querySelector('.page-content.organization')) return;
  initOrgTeamSettings();
  initOrgTeamSearchRepoBox();
}
